// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"4d6b42c7","204":"861408c6","255":"52dc2800","300":"0faf9a5b","822":"9f54194b","985":"468bb3a0"}[chunkId] + ".chunk.js";
};